export default "__VITE_ASSET__DALaJpae__"